export const STAFF_EDIT = "staff.edit";
export const STAFF_VIEW = "staff.view";
export const STAFF_CREATE = "staff.create";
export const STAFF_EDIT_PERMISSIONS = "staff.edit_permissions";
export const STAFF_VIEW_BIO = "staff.view_bio";
export const STAFF_EDIT_BIO = "staff.edit_bio";

export const CENTER_EDIT_NOTES = "center.edit_notes";
export const CENTER_EDIT_HOURS = "center.edit_hours";
export const CENTER_VIEW_WEBSITE = "center.view_website";
export const CENTER_EDIT_WEBSITE = "center.edit_website";

export const STUDENT_MANAGEMENT_VIEW = "student_management.view";
export const STUDENT_FAMILY_VIEW = "student_family.view";
export const STUDENT_FAMILY_CREATE_EDIT = "student_family.create_edit";

export const INQUIRY_EDIT = "inquiry.edit";
export const INQUIRY_VIEW = "inquiry.view";

export const SCHEDULE_VIEW = "schedule.view";
export const SCHEDULE_EDIT = "schedule.edit";

export const MCP_PRIMARY_CENTER_DIRECTOR = "mcp.primary_center_director";

const allPermissions = [
  STAFF_VIEW,
  STAFF_EDIT,
  STAFF_CREATE,
  STAFF_EDIT_PERMISSIONS,
  STAFF_VIEW_BIO,
  STAFF_EDIT_BIO,

  CENTER_EDIT_NOTES,
  CENTER_EDIT_HOURS,

  STUDENT_MANAGEMENT_VIEW,
  STUDENT_FAMILY_VIEW,
  STUDENT_FAMILY_CREATE_EDIT,

  INQUIRY_EDIT,
  INQUIRY_VIEW,

  SCHEDULE_VIEW,
  SCHEDULE_EDIT,

  CENTER_VIEW_WEBSITE,
  CENTER_EDIT_WEBSITE
];

export type Permission = (typeof allPermissions)[number];

export const CORPORATE_USER_PERMISSIONS: Record<Permission, boolean> = {
  [CENTER_VIEW_WEBSITE]: true,
  [INQUIRY_VIEW]: true,
  [STAFF_VIEW]: true,
  [STAFF_VIEW_BIO]: true,
  [STUDENT_FAMILY_VIEW]: true,
  [SCHEDULE_VIEW]: true,
  [STUDENT_MANAGEMENT_VIEW]: true
};
